import mongoose from 'mongoose';
import schema, { IAvailabilityLogDocument } from '../schemas/availability-logs';

const AvailabilityLogs = (mongoose.models.AvailabilityLogs ||
  mongoose.model<IAvailabilityLogDocument>('AvailabilityLogs', schema)) as mongoose.Model<
  IAvailabilityLogDocument
>;

export default AvailabilityLogs;
